import { __enum_PageMode, } from "../Dictionaries";
import { isNullUndefined, isNullUndefinedOrEmpty } from "../Helpers";

export const checkSecurityAdmin_KPI = (_securityProps) => {
    let hasPrivileges = false;

    try {
        hasPrivileges = (_securityProps.isAdmin || _securityProps.isSAdmin)
        
        return hasPrivileges;
    } catch (e) {
        return hasPrivileges;
    }
};

export const _checkSecurityUser_And_ResponsibleInsert = (roleResponsibleInsert_Code, onlyObserver, _userPropsKpi, _securityProps, elementId, objActionToEvaluate, elementRoles, systemRoles) => {
    let matrixSecurityResponse = _checkSecurityUser(onlyObserver, _userPropsKpi, _securityProps, elementId, objActionToEvaluate)

    if (onlyObserver === true) {
        matrixSecurityResponse.roleAssignedExistInMatrix = null;
        return matrixSecurityResponse;
    }
    else {
        if (_securityProps.isSAdmin) {
            matrixSecurityResponse.roleAssignedExistInMatrix = null;
            return matrixSecurityResponse;
        }
        else if ((_userPropsKpi?.isAdmin) || _securityProps.isAdmin) {
            matrixSecurityResponse.roleAssignedExistInMatrix = null;
            return matrixSecurityResponse;
        }
        else {
            if (!isNullUndefinedOrEmpty(elementId)) {  
                const matchedElement = _userPropsKpi.l_privilegeselement.find(y => y.elementId === elementId);

                if (!isNullUndefinedOrEmpty(matchedElement)) {
                    //[#solucion pmz#]
                    let mustForceResponsibleRol = false;
                    if (!isNullUndefined(_userPropsKpi?.isSupplier) && _userPropsKpi.isSupplier === true && isNullUndefinedOrEmpty(roleResponsibleInsert_Code)) {
                        mustForceResponsibleRol = true;
                    }

                    if (!isNullUndefinedOrEmpty(roleResponsibleInsert_Code) || mustForceResponsibleRol) {
                        const actionRolePrivilege = matchedElement.l_item_member.find(x => x.l_matrix.some(y => y.roleCode === roleResponsibleInsert_Code && y.actionCode === objActionToEvaluate))
    
                        if (actionRolePrivilege !== undefined) {         
                            return { value: true, mode: __enum_PageMode.Edit, roleAssignedExistInMatrix: true }
                        }
                        else {
                            try {
                                const responsibleInsertId = systemRoles.find(x => x.privlegeRoleCode === roleResponsibleInsert_Code).id;
                                const userElementRoleResponsibleInsert = elementRoles.find(x => x.username === _securityProps.username && x.privilegeRoleId === responsibleInsertId);
    
                                if (userElementRoleResponsibleInsert !== undefined) {
                                    matrixSecurityResponse.roleAssignedExistInMatrix = true
                                    matrixSecurityResponse.value = true;
                                    matrixSecurityResponse.mode = __enum_PageMode.Edit;
                                }
                                else {
                                    matrixSecurityResponse.roleAssignedExistInMatrix = false
                                }
                            } catch (error) {
                                matrixSecurityResponse.roleAssignedExistInMatrix = false
                            }

                            return matrixSecurityResponse;
                        }
                    }
                    else {
                        matrixSecurityResponse.roleAssignedExistInMatrix = null;
                        return matrixSecurityResponse;
                    }
                }
                else {
                    matrixSecurityResponse.roleAssignedExistInMatrix = null;
                    return matrixSecurityResponse;
                }
            }
            else {
                matrixSecurityResponse.roleAssignedExistInMatrix = null;
                return matrixSecurityResponse;
            }
        }
    }
}

export const _checkSecurityUser = (onlyObserver, _userPropsKpi, _securityProps, elementId, objActionToEvaluate) => {
    //Usado para el Return
    let hasAccess = { value: false, mode: __enum_PageMode.None};

    //Bool que indica si posee o no privilegios en validación de elemento de negocio.
    let hasElementPrivileges = false;
    let matchedElement = undefined;

    //Bool que indica si posee permisos según acción configurada en roles de matriz de permisos.
    let hasAdminProfilePrivileges = false;

    try {

        if (onlyObserver === true) {
            hasAccess.mode = __enum_PageMode.View;
            return hasAccess;
        }
        else {
            if (_securityProps.isSAdmin) {
                hasAdminProfilePrivileges = _securityProps.isSAdmin;
            }
            else if ((_userPropsKpi?.isAdmin) || _securityProps.isAdmin) {
                hasAdminProfilePrivileges = _userPropsKpi.isAdmin || _securityProps.isAdmin;
            }
            else {
                if (!isNullUndefinedOrEmpty(elementId)) {  
                    matchedElement = _userPropsKpi.l_privilegeselement.find(y => y.elementId === elementId);

                    if (!isNullUndefinedOrEmpty(matchedElement)) {
                        hasElementPrivileges = true;
                    }
                }
                else {
                    hasAccess.mode = __enum_PageMode.View;
                    return hasAccess;
                }
            }

            if (hasAdminProfilePrivileges) {
                hasAccess.value = true;
                hasAccess.mode = __enum_PageMode.Edit;
                return hasAccess;
            }

            if (hasElementPrivileges) {
                let currentHasActionRolePrivilege = undefined;

                if (Array.isArray(objActionToEvaluate) && objActionToEvaluate !== null) {
                    console.log()
                    matchedElement.l_item_member.forEach(item_member => {
                        console.log()
                        item_member.l_matrix.forEach(matrix => {
                            console.log()
                            if (currentHasActionRolePrivilege !== true) {
                                console.log()
                                currentHasActionRolePrivilege = objActionToEvaluate.filter(ac => ac === matrix.actionCode).length > 0;
                            }
                            console.log()
                        });
                    });
                }
                else if ((typeof objActionToEvaluate === 'object' || typeof objActionToEvaluate === 'string') && objActionToEvaluate !== null) {
                    console.log()
                    currentHasActionRolePrivilege = matchedElement.l_item_member.some(x => x.l_matrix.some(y => y.actionCode === objActionToEvaluate))
                }
                else {
                    console.log()
                    currentHasActionRolePrivilege = matchedElement.l_item_member.some(x => x.l_matrix.some(y => y.actionCode === objActionToEvaluate))
                }

                if (!isNullUndefined(currentHasActionRolePrivilege) && currentHasActionRolePrivilege !== false) {
                    hasAccess.value = hasElementPrivileges
                    hasAccess.mode = __enum_PageMode.Edit
                }
                else {
                    hasAccess.value = hasElementPrivileges;
                    hasAccess.mode = __enum_PageMode.View
                }
            }
            else {
                hasAccess.value = hasElementPrivileges;
                hasAccess.mode = __enum_PageMode.View
            }

            return hasAccess;
        }
    } catch (e) {
        return hasAccess;
    }
};

export const _checkSecurityUserAux = (onlyObserver, _userPropsKpi, _securityProps, elementId, objActionToEvaluate) => {
    //Usado para el Return
    let hasAccess = { value: false, mode: __enum_PageMode.None};

    //Bool que indica si posee o no privilegios en validación de elemento de negocio.
    let hasElementPrivileges = false;
    let matchedElement = undefined;

    //Bool que indica si posee permisos según acción configurada en roles de matriz de permisos.
    let hasAdminProfilePrivileges = false;

    try {

        if (onlyObserver === true) {
            hasAccess.mode = __enum_PageMode.View;
            return hasAccess;
        }
        else {
            if (_securityProps.isSAdmin) {
                hasAdminProfilePrivileges = _securityProps.isSAdmin;
            }
            else if ((_userPropsKpi?.isAdmin) || _securityProps.isAdmin) {
                hasAdminProfilePrivileges = _userPropsKpi.isAdmin || _securityProps.isAdmin;
            }
            else {
                if (!isNullUndefinedOrEmpty(elementId)) {  
                    matchedElement = _userPropsKpi.l_privilegeselement.find(y => y.elementId === elementId);

                    if (!isNullUndefinedOrEmpty(matchedElement)) {
                        hasElementPrivileges = true;
                    }
                }
                else {
                    hasAccess.mode = __enum_PageMode.View;
                    return hasAccess;
                }
            }

            if (hasAdminProfilePrivileges) {
                hasAccess.value = true;
                hasAccess.mode = __enum_PageMode.Edit;
                return hasAccess;
            }

            if (hasElementPrivileges) {
                let currentHasActionRolePrivilege = undefined;

                if (Array.isArray(objActionToEvaluate) && objActionToEvaluate !== null) {
                    console.log()
                    matchedElement.l_item_member.forEach(item_member => {
                        console.log()
                        item_member.l_matrix.forEach(matrix => {
                            console.log()
                            if (currentHasActionRolePrivilege !== true) {
                                console.log()
                                currentHasActionRolePrivilege = objActionToEvaluate.filter(ac => ac === matrix.actionCode).length > 0;
                            }
                            console.log()
                        });
                    });
                }
                else if ((typeof objActionToEvaluate === 'object' || typeof objActionToEvaluate === 'string') && objActionToEvaluate !== null) {
                    console.log()
                    currentHasActionRolePrivilege = matchedElement.l_item_member.some(x => x.l_matrix.some(y => y.actionCode === objActionToEvaluate))
                }
                else {
                    console.log()
                    currentHasActionRolePrivilege = matchedElement.l_item_member.some(x => x.l_matrix.some(y => y.actionCode === objActionToEvaluate))
                }

                if (!isNullUndefined(currentHasActionRolePrivilege) && currentHasActionRolePrivilege !== false) {
                    hasAccess.value = hasElementPrivileges
                    hasAccess.mode = __enum_PageMode.Edit
                }
                else {
                    hasAccess.value = currentHasActionRolePrivilege;
                    hasAccess.mode = __enum_PageMode.View
                }
            }
            else {
                hasAccess.value = hasElementPrivileges;
                hasAccess.mode = __enum_PageMode.View
            }

            return hasAccess;
        }
    } catch (e) {
        return hasAccess;
    }
};